import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { MainNavigationActions } from '../../../core/router/actions/main-navigation.action';
import { BaseAppState } from '../../../core/store/reducers';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'local-app-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['footer.component.scss'],
})
export class AppFooterComponent {
  public faqUrl = `${environment.userApp}/faq#dateneingabe`;

  constructor(private store: Store<BaseAppState>) {}

  handlePrivacyPolicyClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.store.dispatch(MainNavigationActions.goToPrivacyPolicy());
  }

  handleJointResponsibilityAgreementClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.store.dispatch(MainNavigationActions.goToJointResponsibilityAgreement());
  }

  handleLegalNoticeClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.store.dispatch(MainNavigationActions.goToLegalNotice());
  }
}
